import React from 'react'
import { withStyles } from '@material-ui/core'
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter } from '@material-ui/core'
import { get } from 'lodash'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
	table: {
		minWidth: 700,
	},
	bgBlack: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		border: 'solid 1px lightgrey',
	},
	bgBlueGrey: {
		backgroundColor: '#424242',
		color: theme.palette.common.white,
		border: 'solid 1px lightgrey',
	},
	bgWhite: {
		border: '1px solid #ffffff',
	},
	bgLightBlue: {
		backgroundColor: '#dbe5f1',
		color: theme.palette.common.black,
		border: '1px solid white',
	},
	bgLightGreen: {
		backgroundColor: '#6fcdb3',
		color: theme.palette.common.black,
		border: '1px solid white',
	},
	noBorder: {
		border: '0 !important',
	},
	emptyRow: {
		height: '40px !important',
	},
	leftJustified: {
		textAlign: 'left !important',
	},
	reportTableContainer: {
		overflowX: 'scroll',
		paddingBottom: '15px'
	},
}))

const StyledTableCell = withStyles(theme => ({
	head: {
		padding: theme.spacing(1),
		fontSize: 12,
		border: 'solid 1px lightgrey',
		textAlign: 'center',
		whiteSpace: 'nowrap',
	},
	body: {
		fontSize: 11,
		textAlign: 'center',
		whiteSpace: 'nowrap',
	},
	footer: {
		textAlign: 'center',
	},
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
	root: {
		height: 'auto',
	},
}))(TableRow)

export default function PerformanceRatingOrgDetailReport(props) {

	const classes = useStyles()

	return (
		<div className={classes.reportTableContainer}>
			<Table id="PerformanceRatingOrgDetailReport" className={classes.reportTable} size="small">
				<TableHead>
					<TableRow>
						<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
							{
								props.groups.map(group=>
									<React.Fragment key={group}>
										<StyledTableCell colSpan={5}>{props.groupsNames[group]}</StyledTableCell>
										<StyledTableCell className={classes.noBorder}></StyledTableCell>
									</React.Fragment>
								)
							}
					</TableRow>
					<TableRow>
						<StyledTableCell className={clsx(classes.bgBlack, classes.noBorder)}>
							Global Grade
						</StyledTableCell>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										{'Cat/Level'}
									</StyledTableCell>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										Job Title
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										Average Rating
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}>
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
				</TableHead>
				<TableBody>
					{
						props.levelsData.map((levelData, i) => {
							return (
								<StyledTableRow key={i}>
									<StyledTableCell className={classes.bgBlack}>
										{i}
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
									{
										props.groups.map(group => {
											const groupLevelData = levelData[group]
											const level = get(groupLevelData, 'level', '')
											return (
												<React.Fragment key={`${i}${group}`}>
													<StyledTableCell className={level ? classes.bgBlack : classes.bgWhite}>
														{get(groupLevelData, 'level', '')}
													</StyledTableCell>
													<StyledTableCell align="left" className={clsx(classes.leftJustified, level ? classes.bgBlack : classes.bgWhite)}>
														{get(groupLevelData, 'title', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.n', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.averageRating', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.percent', '')}
													</StyledTableCell>
													<StyledTableCell className={classes.noBorder}>
													</StyledTableCell>
												</React.Fragment>
											)
										})
									}
								</StyledTableRow>
							)
						})
					}
					<StyledTableRow>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
					</StyledTableRow>
				</TableBody>
				<TableFooter>
					<StyledTableRow>
						<StyledTableCell colSpan={1} className={classes.bgLightGreen}>Total {props.currentTotalN}</StyledTableCell>
						{
							Object.keys(props.groupSummary).map(key => {
								return (
									<React.Fragment key={key}>
										<StyledTableCell colSpan={3} className={classes.noBorder}></StyledTableCell>
										<StyledTableCell className={classes.bgLightGreen}>
											{props.groupSummary[key].current.totalN}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
											{props.groupSummary[key].current.total_average_rating }
									</StyledTableCell>
										<StyledTableCell className={classes.bgLightGreen}>
											{props.groupSummary[key].current.totalPercent}
									</StyledTableCell>
									</React.Fragment>
								)
							})
						}
					</StyledTableRow>
				</TableFooter>
			</Table>
		</div>
	)
}
